import {IReportItemComponent} from '../../models/i-report-item-component';
import { Component, OnInit, Input } from '@angular/core';
import { AssessmentResult } from "../../../shared/models/assessment-result";
import { ScaleResult } from "../../../shared/models/scale-result";
import { Variable } from "../../models/variable";
import { ScaleDataSectionComponent } from 'app/reports/models/scale-list-data-component';

@Component({
  selector: 'app-scale-results-sections-list',
  templateUrl: './scale-results-sections-list.component.html'
})
export class ScaleResultsSectionsListComponent extends ScaleDataSectionComponent implements OnInit {

  constructor() { 
    super();
  }

  public getHTMLClassNames() : string[] {
    return ["scale-results", "report-item-component"];
  }

  ngOnInit() {
    
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/scale-results-sections-list/scale-results-sections-list.component.ts